export default {"src":"/_next/static/media/likelihood_icon.2df311e4.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};